import { GetAllContentsInDto } from '../../../types/content.dto'

export const GET_ALL_CONTENTS_STATICS = 'GET_ALL_CONTENTS_STATICS'
export const GET_ALL_CONTENTS_STATICS_SUCCESS = 'GET_ALL_CONTENTS_STATICS_SUCCESS'
export const GET_ALL_CONTENTS_STATICS_ERROR = 'GET_ALL_CONTENTS_STATICS_ERROR'
export const RESET_GET_ALL_CONTENTS_STATICS = 'RESET_GET_ALL_CONTENTS_STATICS'

export interface GetAllContentsStatics {
  type: typeof GET_ALL_CONTENTS_STATICS
  payload: null
}

export interface GetAllContentsStaticsSuccess {
  type: typeof GET_ALL_CONTENTS_STATICS_SUCCESS
  payload: GetAllContentsInDto
}

export interface GetAllContentsStaticsError {
  type: typeof GET_ALL_CONTENTS_STATICS_ERROR
  payload: string | boolean
}

export interface ResetGetAllContentsStatics {
  type: typeof RESET_GET_ALL_CONTENTS_STATICS
  payload: null
}

export interface State {
  data: GetAllContentsInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions =
  | GetAllContentsStatics
  | GetAllContentsStaticsSuccess
  | GetAllContentsStaticsError
  | ResetGetAllContentsStatics
